import {
  App,
  routes as allRoutes,
  fullEndpoints,
} from "@songtradr-sso/shared/common";
import { staticText } from "../../../shared/statics/static-text";

// TEXT
export const text = staticText.authButtons.providers;

// STYLES

// DATA

// TYPES

// CONSTANTS
export const routes = allRoutes[App.Core];
export const endpoints = fullEndpoints[App.Core].auth;

// FUNCTIONS

// ASSETS
